module.exports = __webpack_public_path__ + "static/media/27OCHA13.05008223.jpg";